import { render, staticRenderFns } from "./noCoughDetected.vue?vue&type=template&id=d5a78b0a&"
import script from "./noCoughDetected.vue?vue&type=script&lang=js&"
export * from "./noCoughDetected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports